import { createSelector } from 'reselect';

import { findIntercom, getFilteredMenuItems } from '~/src/store/actions/menu';
import { selectNewMenuItems } from '~/src/store/selectors/menu/selectMenu';

export const selectHasIntercom = createSelector(selectNewMenuItems, menuItems => {
    if (!menuItems) {
        return false;
    }
    const { authMain = [], unauthMain = [] } = menuItems;
    return !!(getFilteredMenuItems([...authMain, ...unauthMain], findIntercom).length);
});
